import React, { useEffect, useState } from "react";
import {
	CancelOrder,
	CancelOrderByAdmin,
	createdPass,
	FinishOrderByAdmin,
	PaidOrderByAdmin,
} from "../../../../services/OrderService";
import User, { UserRole } from "../../../../models/User";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";

export default function useFinishOrder(props: {
	reload: () => void;
	user?: User | null;
	setLoad: (val: boolean) => void;
}) {
	const { openAlertDialog } = useAlertDialog();
	const doFinishOrder = async (id: number) => {
		props.setLoad(true);
		try {
			await FinishOrderByAdmin(id);
			props.setLoad(false);
			openAlertDialog?.(AlertType.Success, "Finish successfully!", () => {
				props.reload();
			});
		} catch (err: any) {
			console.error(err);
			props.setLoad(false);
			openAlertDialog?.(AlertType.Fail, err?.response.data?.message || "Finish Fail!");
		}
	};

	return {
		doFinishOrder,
	};
}
